import React from 'react';
import GigPage from '../components/GigPage';

const GigPageClient = (props) => (
    <GigPage {...props}/>
);

export default GigPageClient;
